import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, CalendarCheck, ArrowRight } from 'lucide-react';

const formatDate = (iso) => {
  try {
    return new Date(`${iso}T12:00:00`).toLocaleDateString('fr-FR', {
      weekday: 'long', day: 'numeric', month: 'long',
    });
  } catch (e) {
    return iso;
  }
};

const UpcomingTowns = () => {
  const [towns, setTowns] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/upcoming-towns?limit=3`);
        if (!res.ok) return;
        const data = await res.json();
        if (active && Array.isArray(data?.towns)) setTowns(data.towns);
      } catch (e) {
        /* non-blocking */
      }
    })();
    return () => { active = false; };
  }, []);

  if (towns.length === 0) return null;

  return (
    <section className="py-12 lg:py-16 bg-gradient-to-br from-amber-50 to-emerald-50" data-testid="upcoming-towns-section">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-amber-400 text-emerald-950 px-4 py-1.5 rounded-full text-sm font-bold mb-3">
              <MapPin size={16} /> Prochainement près de chez vous
            </div>
            <h2 className="text-2xl lg:text-3xl font-bold text-gray-900">Mes prochains passages en Vendée</h2>
            <p className="text-gray-600 mt-2 max-w-xl mx-auto">
              Je serai bientôt dans ces communes — réservez votre créneau avant que je passe près de chez vous.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {towns.map((t) => (
              <Link
                key={t.town_slug}
                to={`/zone/${t.town_slug}`}
                data-testid={`upcoming-town-${t.town_slug}`}
                className="group bg-white rounded-2xl shadow-sm hover:shadow-lg border border-emerald-100 p-5 transition-all"
              >
                <div className="flex items-center gap-2 text-emerald-700 font-bold text-lg mb-1">
                  <MapPin size={18} className="flex-shrink-0" /> {t.town_display}
                </div>
                <div className="flex items-center gap-1.5 text-sm text-gray-600 mb-3">
                  <CalendarCheck size={15} className="text-amber-600 flex-shrink-0" />
                  <span className="capitalize">{formatDate(t.date_intervention)}</span>
                </div>
                {t.service_label && <p className="text-xs text-gray-500 mb-3">{t.service_label}</p>}
                <span className="inline-flex items-center gap-1 text-emerald-600 group-hover:text-emerald-700 text-sm font-semibold">
                  Réserver un passage <ArrowRight size={15} className="group-hover:translate-x-0.5 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingTowns;
